import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { valuationByHash } from 'src/app/models/valuation.model';
import { slideInOutAnimation } from 'src/app/route-animations';
import { storedValudationData } from '../../models/urlAuthParams.model';
import { ApiService } from '../../services/api.service';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { buyValuationByCustomer } from 'src/app/models/valuation-request';
import { ValuationService } from '../../services/valuation.service';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';
import { LicensePipe } from '../../pipes/license.pipe';

@Component({
  selector: 'app-accept-offer',
  templateUrl: './accept-offer.component.html',
  styleUrls: ['./accept-offer.component.scss'],
  animations: [slideInOutAnimation],
  host: { '[@slideInOutAnimation]': '' },
  standalone: true,
  imports: [...SHARED_IMPORTS, LicensePipe],
})
export class AcceptOfferComponent implements OnInit {
  public validationForm: UntypedFormGroup;
  public customPickupAddress = null;
  public rdwCodesKnown = false;
  public submitted = false;
  public valuationData: valuationByHash;
  public faLock = faLock;

  constructor(
    public fb: UntypedFormBuilder,
    private readonly ngxService: NgxUiLoaderService,
    private readonly router: Router,
    private readonly api: ApiService,
    private readonly valuationService: ValuationService,
    private readonly route: ActivatedRoute,
  ) {
    //localStorage.setItem('state', '/accepteren');
    this.validationForm = fb.group({
      firstName: [null, [Validators.required, Validators.minLength(2)]],
      infix: [null],
      lastName: [null, [Validators.required, Validators.minLength(2)]],
      phoneNumber: [null, [Validators.required, Validators.minLength(10)]],
      agreement: [null, Validators.requiredTrue],
      agreementBid: [null, Validators.requiredTrue],
    });
  }

  public ngOnInit(): void {
    this.ngxService.start();
    // Get route params used in servcie
    this.route.params.subscribe((routeParams) => {
      // Sync data
      this.valuationService.syncValuationData(routeParams).then(data => {
        this.valuationData = data;
        // navigate to correct page when valuation has status bough.
        if (this.valuationData.StatusType.name == 'buy') {
          this.router.navigate(['/verificatie']);
        }
      })
    });
  }

  // Used to shortcut to form for validation.
  public get f() { return this.validationForm.controls; }

  public onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.validationForm.invalid) {
      return;
    } else {
      this.ngxService.start();
      const submitData: buyValuationByCustomer = {
        customerFirstName: this.validationForm.controls['firstName'].value,
        customerInfix: this.validationForm.controls['infix'].value,
        customerLastName: this.validationForm.controls['lastName'].value,
        customerPhone: this.validationForm.controls['phoneNumber'].value.replace(/\s/g, ""),
      }
      // Submit data
      const valuationAuth: storedValudationData = JSON.parse(localStorage.getItem('valuation'));
      // Execute api call
      this.api.buyValuationByCustomer(valuationAuth.id, valuationAuth.hash, submitData).subscribe(data => {
        if (data.error == false) {
          this.ngxService.stop();
          // Push Tag manager purchase event

          // First accept_bid disabled after meeting 09-04-2025
          /*
          window['dataLayer'] = window['dataLayer'] || [];
          window['dataLayer'].push({ value: 0});
          window['dataLayer'].push({ currency: 'EUR' });
          window['dataLayer'].push({ valuation_id: this.valuationData.id });
          window['dataLayer'].push({ event: 'accept_bid' });*/

          setTimeout(() => {
            localStorage.setItem('acceptForm', JSON.stringify(submitData))
            this.shoot();
            localStorage.setItem('state', '/bedankt-accepteren');
            this.router.navigate(['/bedankt-accepteren']);
          }, 500);
        } else {
          localStorage.setItem('acceptForm', JSON.stringify(submitData))
          this.ngxService.stop();
          if (data.message == 'Not allowed') {
            this.router.navigate(['/error', { errorType: 'not-allowed' }]);
          } else {
            this.router.navigate(['/error', { errorType: 'response-error' }]);
          }
        }
      })
    }
  }

  public shoot() {
    try {
      this.confetti({
        angle: 90,
        spread: 100,
        particleCount: 120,
        origin: {
          y: 0.6
        }
      });
    } catch (e) {
      // noop, confettijs may not be loaded yet
    }
  }

  confetti(args: any) {
    return window['confetti'].apply(this, arguments);
  }
}
